// Download utility function
export const downloadFileFromBlobUrl = (blobUrl: string, fileName: string) => {
    // Create an anchor element to trigger the download
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Optional: Revoke the Blob URL
    URL.revokeObjectURL(blobUrl);
};